export const COULD_NOT_FINISH = "We could not finish this article. Retry.";

export const RESEARCH_FIRST =
  "Research this cluster first. Articles are written from a researched dossier.";

/** Map a stored LastError into a sentence the customer can act on. Never returns JSON bodies. */
export function mapGenerationError(raw) {
  if (!raw) return null;
  const s = String(raw);
  if (
    /PaymentRequired|Insufficient Credits|LLM credits|API Error:/i.test(s) ||
    /BODY\s*:/i.test(s) ||
    /"status"\s*:/.test(s)
  ) {
    return COULD_NOT_FINISH;
  }
  if (/Research this cluster first/i.test(s)) return RESEARCH_FIRST;
  const stripped = s.replace(/\s*BODY:[\s\S]*$/i, "").trim();
  if (!stripped || stripped.length > 180) return COULD_NOT_FINISH;
  return stripped;
}
